export const NET_PREMIUM_DATA_REQUEST = 'NET_PREMIUM_DATA_REQUEST';
export const NET_PREMIUM_DATA_SUCCESS = 'NET_PREMIUM_DATA_SUCCESS';
export const NET_PREMIUM_DATA_FAIL = 'NET_PREMIUM_DATA_FAIL';
